export default [
  {
    path: "/field5ydcdmh", // 无视频
    name: "field5ydcdmh",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field5ydks")
  },
  {
    path: "/field8ydcdmh", // 无视频
    name: "field8ydcdmh",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field8ydks")
  },
  {
    path: "/field9ydcdmh",
    name: "field9ydcdmh",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field9ydks")
  },
  {
    path: "/field12ydcdmh", // 无视频
    name: "field12ydcdmh",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field12ydks")
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/cdmh.js